import { indexItems } from '@/mocks/home';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
              专题索引
            </span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">
              电影专题合集
            </h2>
            <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
              按主题快速浏览，精准定位你想看的电影类型
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {indexItems.map((item) => (
              <a
                key={item.id}
                href="#carousel"
                className="group flex items-center gap-4 bg-background-100 rounded-xl p-4 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
              >
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${colorMap[item.color] || colorMap.primary}`}>
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-bold text-foreground-900 whitespace-nowrap group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-400">{item.count} 部影片</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}